/* Ordering grid for church store collections.

   TWO MODES, set by window.SMC_SINGLE_POPUP from the Liquid snippet:
     false (member/wholesale stores, handle number < 9501) — a card opens
       the compact size popup, and "Full details" opens the larger view.
     true  (retail stores, 9501+) — a card opens the full-details view
       directly. The compact popup never appears; retail shoppers buy one
       or two pieces and want the photo and description up front, not a
       bulk size grid.
   Both modes share the same colour buttons and size tiles.

   CART SYNC. `desired` is what the customer has tapped and is the only
   source of truth for the UI. `server` is what Shopify last told us it
   holds. A flush sends the difference and re-reads the cart. An earlier
   version overwrote `desired` from the cart on every read, which silently
   threw away any tap made while a request was in flight — that was the
   "sometimes it adds, sometimes it doesn't" bug. `desired` is now only
   reset from the server on first load or after a real failure, and the
   flush loops until the two agree.

   Pricing: if the visitor may not order, the Liquid snippet never emitted
   prices, so there is nothing here to leak. */
(function () {
  var root = document.querySelector('[data-member-order]');
  var dataEl = document.querySelector('[data-mo-data]');
  if (!root || !dataEl) return;

  var PRODUCTS = [];
  try {
    PRODUCTS = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Order grid: could not parse product data', e);
    return;
  }

  var SINGLE = !!window.SMC_SINGLE_POPUP;

  var grid = root.querySelector('[data-mo-grid]');
  var rail = root.querySelector('[data-mo-rail]');
  var searchEl = root.querySelector('[data-mo-search]');
  var scrim = document.querySelector('[data-mo-scrim]');
  var modal = document.querySelector('[data-mo-modal]');
  var qscrim = document.querySelector('[data-mo-qscrim]');
  var qvEl = document.querySelector('[data-mo-qv]');
  var toastEl = document.querySelector('[data-mo-toast]');
  var bar = document.querySelector('[data-mo-bar]');
  var drawer = document.querySelector('[data-mo-drawer]');

  var filter = 'all';
  var search = '';
  var openId = null;
  var qvId = null;
  var chosen = {};

  var desired = {};
  var server = {};
  var seeded = false;
  var syncTimer = null;
  var syncing = false;
  var requeue = false;

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var fmt = window.SMC_MONEY_FORMAT || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString());
  }
  function byId(id) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].id === id) return PRODUCTS[i];
    return null;
  }
  function variantOf(p, vid) {
    for (var i = 0; i < p.v.length; i++) if (p.v[i].id === vid) return p.v[i];
    return null;
  }

  /* Option layout differs per product: Design/Color/Size, Color/Size, and
     Beanies are Size/Color the other way round. Find the size option by
     name, treat everything else as the colour label. */
  function shape(p) {
    if (p._shape) return p._shape;
    var names = p.on || [];
    var sizeIdx = -1;
    for (var i = 0; i < names.length; i++) {
      if (/size/i.test(names[i])) { sizeIdx = i; break; }
    }
    if (sizeIdx === -1) sizeIdx = names.length - 1;

    var colours = [];
    var byColour = {};
    p.v.forEach(function (v) {
      var parts = [];
      for (var j = 0; j < v.o.length; j++) if (j !== sizeIdx) parts.push(v.o[j]);
      var key = parts.join(' / ') || 'One option';
      if (!byColour[key]) { byColour[key] = []; colours.push(key); }
      byColour[key].push(v);
    });
    p._shape = {
      sizeIdx: sizeIdx, colours: colours, byColour: byColour,
      oneSize: colours.length > 0 && byColour[colours[0]].length === 1
    };
    return p._shape;
  }
  function sizeName(p, v) { return v.o[shape(p).sizeIdx]; }
  function colourOf(p, v) {
    var s = shape(p);
    for (var i = 0; i < s.colours.length; i++) {
      if (s.byColour[s.colours[i]].indexOf(v) !== -1) return s.colours[i];
    }
    return '';
  }
  function colourImage(p, colour) {
    var list = shape(p).byColour[colour] || [];
    for (var i = 0; i < list.length; i++) if (list[i].img) return list[i].img;
    return p.img;
  }
  function anyAvailable(p) { return p.v.some(function (v) { return v.a; }); }
  function firstStockedColour(p) {
    var s = shape(p);
    for (var i = 0; i < s.colours.length; i++) {
      if (s.byColour[s.colours[i]].some(function (v) { return v.a; })) return i;
    }
    return 0;
  }
  function colourIdx(p) {
    if (chosen[p.id] === undefined) chosen[p.id] = firstStockedColour(p);
    return chosen[p.id];
  }
  function productQty(p) {
    return p.v.reduce(function (n, v) { return n + (desired[v.id] || 0); }, 0);
  }
  function cheapest(p) {
    var prices = p.v.filter(function (v) { return typeof v.p === 'number'; }).map(function (v) { return v.p; });
    return prices.length ? money(Math.min.apply(null, prices)) : '';
  }

  /* ---------- shared controls ---------- */
  function colourButtons(p, ctx) {
    var s = shape(p);
    if (s.colours.length < 2) return '';
    var ci = colourIdx(p);
    return '<p class="mo-lb">Colour <span>' + esc(s.colours[ci]) + '</span></p><div class="mo-colours">' +
      s.colours.map(function (c, i) {
        return '<button type="button" class="mo-colour' + (i === ci ? ' is-active' : '') +
          '" data-mo-colour="' + i + '" data-mo-pid="' + p.id + '" data-mo-ctx="' + ctx + '">' +
          '<img class="mo-colour__tn" src="' + esc(colourImage(p, c)) + '" alt="" loading="lazy">' +
          esc(c) + '</button>';
      }).join('') + '</div>';
  }
  function galleryThumbs(p) {
    var s = shape(p);
    if (s.colours.length < 2) return '';
    var ci = colourIdx(p);
    return '<div class="mo-qv__thumbs">' + s.colours.map(function (c, i) {
      return '<button type="button" class="mo-qv__thumb' + (i === ci ? ' is-active' : '') +
        '" data-mo-colour="' + i + '" data-mo-pid="' + p.id + '" data-mo-ctx="qv"' +
        ' title="' + esc(c) + '" aria-label="' + esc(c) + '">' +
        '<img src="' + esc(colourImage(p, c)) + '" alt="' + esc(c) + '" loading="lazy"></button>';
    }).join('') + '</div>';
  }
  function sizeTiles(p) {
    var s = shape(p);
    var colour = s.colours[colourIdx(p)];
    var img = colourImage(p, colour);
    return '<div class="mo-sizes">' + (s.byColour[colour] || []).map(function (v) {
      var q = desired[v.id] || 0;
      var label = s.oneSize ? colour : sizeName(p, v).replace(/^Adult\s+/, '');
      var foot = !v.a ? 'Out of Stock' : (p.o ? (v.pf || money(v.p)) : '');
      return '<button type="button" class="mo-size' + (q ? ' is-picked' : '') + '"' +
        ' data-mo-variant="' + v.id + '" data-mo-pid="' + p.id + '"' +
        (v.a && p.o ? '' : ' disabled') + '>' +
        '<img class="mo-size__tn" src="' + esc(img) + '" alt="" loading="lazy">' +
        '<span class="mo-size__count">' + q + '</span>' +
        '<span class="mo-size__minus" data-mo-minus="1" aria-hidden="true">&minus;</span>' +
        esc(label) + '<span class="mo-size__foot">' + esc(foot) + '</span></button>';
    }).join('') + '</div>';
  }
  function sizesHeading(p) {
    return '<p class="mo-lb">' + (shape(p).oneSize ? 'Add to your order' : 'Sizes') + ' <span>' +
      (p.o ? 'Tap to add one — tap again for more' : 'Members only') + '</span></p>';
  }

  /* ---------- grid ---------- */
  function visible() {
    return PRODUCTS.filter(function (p) {
      if (filter !== 'all') {
        var wanted = filter.split('|');
        if (!p.tags.some(function (t) { return wanted.indexOf(t) !== -1; })) return false;
      }
      if (!search) return true;
      return (p.t + ' ' + shape(p).colours.join(' ')).toLowerCase().indexOf(search) !== -1;
    });
  }
  function renderGrid() {
    var list = visible();
    if (!list.length) {
      grid.innerHTML = '<div class="mo-empty"><b>Nothing matches that</b>' +
        'Try a different product type, or clear the search.</div>';
      return;
    }
    grid.innerHTML = list.map(function (p) {
      var s = shape(p);
      var q = productQty(p);
      var out = !anyAvailable(p);
      var sw = s.colours.slice(0, 4).map(function (c) {
        return '<i><img src="' + esc(colourImage(p, c)) + '" alt="" loading="lazy"></i>';
      }).join('') + (s.colours.length > 4 ? '<b>+' + (s.colours.length - 4) + '</b>' : '');
      return '<button type="button" class="mo-card' + (out ? ' is-out' : '') +
        '" data-mo-card="' + p.id + '">' +
        (out ? '<span class="mo-card__out">Out of Stock</span>' : '') +
        '<span class="mo-card__badge" data-mo-card-badge' + (q ? '' : ' hidden') + '>' + q + '</span>' +
        '<span class="mo-card__ph"><img src="' + esc(p.img) + '" alt="" loading="lazy"></span>' +
        '<span class="mo-card__sw">' + sw + '</span>' +
        '<span class="mo-card__in"><span class="mo-card__title">' + esc(p.t) + '</span>' +
        (p.o ? '<span class="mo-card__price">' + esc(cheapest(p)) + '</span>'
             : '<span class="mo-card__locked">Members only</span>') +
        '</span></button>';
    }).join('');
  }

  /* ---------- compact size popup (member stores only) ---------- */
  function openModal(id) {
    openId = id;
    colourIdx(byId(id));
    drawModal();
    scrim.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    openId = null;
    scrim.hidden = true;
    if (!qvId) document.body.style.overflow = '';
  }
  function drawModal() {
    if (!openId) return;
    var p = byId(openId);
    var colour = shape(p).colours[colourIdx(p)];
    modal.innerHTML =
      '<div class="mo-modal__head">' +
        '<button type="button" class="mo-hero" data-mo-quick="' + p.id + '" aria-label="View full product details">' +
          '<img src="' + esc(colourImage(p, colour)) + '" alt="' + esc(p.t) + '">' +
          '<span class="mo-hero__zoom">Full details</span></button>' +
        '<div><p class="mo-modal__title">' + esc(p.t) + '</p>' +
          (p.o ? '<p class="mo-modal__price">' + esc(cheapest(p)) + '</p>' : '') +
          '<p class="mo-modal__blurb">' + esc(p.d) + '</p>' +
          '<button type="button" class="mo-more" data-mo-quick="' + p.id + '">Read full description</button></div>' +
        '<button type="button" class="mo-x" data-mo-close aria-label="Close">&#10005;</button>' +
      '</div>' +
      '<div class="mo-modal__body">' + colourButtons(p, 'modal') + sizesHeading(p) + sizeTiles(p) +
        (p.o
          ? '<p class="mo-hint">Sizes go into your order the moment you tap them — there is no separate ' +
            'add-to-cart step. Tap <b>&minus;</b> on a tile to take one back off.</p>'
          : '<p class="mo-hint">Join as a member to see pricing and order. ' +
            '<a href="' + esc(window.SMC_MEMBERSHIP_URL || '#') + '">Become a Member</a></p>') +
      '</div>' +
      '<div class="mo-modal__foot"><span class="mo-run" data-mo-run></span>' +
        '<button type="button" class="mo-done" data-mo-close>Done</button></div>';
    runTotal();
  }

  /* ---------- full details — orderable, with colour gallery ---------- */
  function openQuick(id) {
    qvId = id;
    colourIdx(byId(id));
    drawQuick();
    qscrim.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeQuick() {
    qvId = null;
    qscrim.hidden = true;
    if (!openId) document.body.style.overflow = '';
  }
  function drawQuick() {
    if (!qvId) return;
    var p = byId(qvId);
    var colour = shape(p).colours[colourIdx(p)];
    qvEl.innerHTML =
      '<div class="mo-qv__img">' +
        '<div class="mo-qv__main"><img src="' + esc(colourImage(p, colour)) + '" alt="' + esc(p.t) + '"></div>' +
        galleryThumbs(p) +
      '</div>' +
      '<div class="mo-qv__side">' +
        '<div class="mo-qv__top"><h2>' + esc(p.t) + '</h2>' +
          '<button type="button" class="mo-x" data-mo-qclose aria-label="Close">&#10005;</button></div>' +
        '<div class="mo-qv__scroll">' +
          (p.o ? '<p class="mo-qv__meta"><b>' + esc(cheapest(p)) + '</b></p>' : '') +
          colourButtons(p, 'qv') + sizesHeading(p) + sizeTiles(p) +
          '<p class="mo-qv__h">About this product</p><p class="mo-qv__desc">' + esc(p.d) + '</p>' +
          '<p class="mo-qv__h">Production</p><p class="mo-qv__desc">Printed to order. ' +
            'No minimums — order a single piece if that is all you need. Production and shipping take ' +
            '3–4 business days.</p>' +
        '</div>' +
        '<div class="mo-qv__foot"><span class="mo-run" data-mo-qrun></span>' +
          '<button type="button" class="mo-btn mo-btn--pri" data-mo-qclose>Done</button></div>' +
      '</div>';
    runTotal();
  }

  /* ---------- in-place refresh, so scroll position holds ---------- */
  function syncTiles() {
    document.querySelectorAll('[data-mo-variant]').forEach(function (tile) {
      var q = desired[+tile.getAttribute('data-mo-variant')] || 0;
      tile.classList.toggle('is-picked', q > 0);
      var c = tile.querySelector('.mo-size__count');
      if (c) c.textContent = q;
    });
    document.querySelectorAll('[data-mo-card]').forEach(function (card) {
      var p = byId(+card.getAttribute('data-mo-card'));
      if (!p) return;
      var q = productQty(p);
      var b = card.querySelector('[data-mo-card-badge]');
      if (b) { b.textContent = q; b.hidden = q === 0; }
    });
    runTotal();
  }
  function runTotal() {
    [['[data-mo-run]', openId], ['[data-mo-qrun]', qvId]].forEach(function (pair) {
      var el = document.querySelector(pair[0]);
      if (!el || !pair[1]) return;
      var p = byId(pair[1]);
      var q = 0, sum = 0;
      p.v.forEach(function (v) {
        var n = desired[v.id] || 0;
        q += n;
        if (typeof v.p === 'number') sum += n * v.p;
      });
      el.innerHTML = 'This product: <b>' + q + (q === 1 ? ' item' : ' items') + '</b>' +
        (p.o ? ' · <b>' + money(sum) + '</b>' : '');
    });
  }

  function bump(pid, vid, delta) {
    var p = byId(pid);
    if (!p) return;
    var next = Math.max(0, (desired[vid] || 0) + delta);
    if (next === (desired[vid] || 0)) return;
    if (next) desired[vid] = next; else delete desired[vid];

    if (delta > 0) {
      var tile = document.querySelector('[data-mo-variant="' + vid + '"]');
      if (tile) { tile.classList.remove('is-bumped'); void tile.offsetWidth; tile.classList.add('is-bumped'); }
      var v = variantOf(p, vid);
      var colour = colourOf(p, v);
      toast(colourImage(p, colour),
        'Added <b>' + esc(shape(p).colours.length > 1 ? colour + ' · ' + sizeName(p, v) : sizeName(p, v)) + '</b>');
    }
    syncTiles();
    paintCart();
    scheduleSync();
  }

  var toastTimer;
  function toast(img, html, isError) {
    toastEl.innerHTML = (img ? '<img src="' + esc(img) + '" alt="">' : '') + html;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, isError ? 4200 : 1900);
  }

  /* ---------- bar + drawer ---------- */
  function paintCart() {
    var q = 0, sum = 0;
    PRODUCTS.forEach(function (p) {
      p.v.forEach(function (v) {
        var n = desired[v.id] || 0;
        q += n;
        if (typeof v.p === 'number') sum += n * v.p;
      });
    });
    document.querySelector('[data-mo-bar-count]').textContent = q + (q === 1 ? ' item' : ' items');
    document.querySelector('[data-mo-bar-total]').textContent = money(sum);
    document.querySelector('[data-mo-drawer-total]').textContent = money(sum);
    bar.classList.toggle('is-visible', q > 0);
    if (!q) drawer.hidden = true;

    var html = '';
    PRODUCTS.forEach(function (p) {
      p.v.forEach(function (v) {
        var n = desired[v.id] || 0;
        if (!n) return;
        var colour = colourOf(p, v);
        html += '<div class="mo-row">' +
          '<img class="mo-row__th" src="' + esc(colourImage(p, colour)) + '" alt="">' +
          '<div><p class="mo-row__n">' + esc(p.t) + '</p>' +
          '<p class="mo-row__m">' + esc(colour) + ' &middot; ' + esc(sizeName(p, v)) + '</p></div>' +
          '<span class="mo-stp">' +
            '<button type="button" data-mo-step="-1" data-mo-pid="' + p.id + '" data-mo-vid="' + v.id + '">&minus;</button>' +
            '<span class="mo-stp__n">' + n + '</span>' +
            '<button type="button" data-mo-step="1" data-mo-pid="' + p.id + '" data-mo-vid="' + v.id + '">+</button>' +
          '</span>' +
          '<span class="mo-row__amt">' + (typeof v.p === 'number' ? money(n * v.p) : '') + '</span>' +
          '<button type="button" class="mo-row__rm" data-mo-remove data-mo-pid="' + p.id +
            '" data-mo-vid="' + v.id + '" aria-label="Remove">&#10005;</button></div>';
      });
    });
    document.querySelector('[data-mo-drawer-rows]').innerHTML =
      html || '<p class="mo-empty" style="padding:28px 10px">Nothing added yet.</p>';
  }

  /* ---------- cart sync ---------- */
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(flush, 400);
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var msg = j.description || j.message || '';
          var err = new Error(msg || ('Cart request failed (' + r.status + ')'));
          err.userMessage = msg;
          throw err;
        }
        return j;
      });
    });
  }
  function differs() {
    var out = false;
    Object.keys(desired).forEach(function (id) { if ((server[id] || 0) !== desired[id]) out = true; });
    Object.keys(server).forEach(function (id) { if (server[id] && !desired[id]) out = true; });
    return out;
  }
  function flush() {
    if (syncing) { requeue = true; return; }
    if (!differs()) return;

    var adds = [], updates = {};
    Object.keys(desired).forEach(function (id) {
      var d = desired[id], s = server[id] || 0;
      if (d === s) return;
      if (!s) adds.push({ id: +id, quantity: d });
      else updates[id] = d;
    });
    Object.keys(server).forEach(function (id) {
      if (server[id] && !desired[id]) updates[id] = 0;
    });

    syncing = true;
    var chain = Promise.resolve();
    if (adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: adds }); });
    if (Object.keys(updates).length) {
      chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
    }

    chain
      .then(function () { return readCart(false); })
      .then(function () {
        syncing = false;
        if (requeue || differs()) { requeue = false; scheduleSync(); }
      })
      .catch(function (err) {
        console.error('Order grid: cart sync failed', err);
        syncing = false;
        requeue = false;
        toast('', err.userMessage
          ? esc(err.userMessage)
          : 'Could not update your order. <b>Please try again.</b>', true);
        return readCart(true);
      });
  }
  function readCart(reseed) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        server = {};
        cart.items.forEach(function (i) { server[i.variant_id] = i.quantity; });
        if (reseed || !seeded) {
          desired = {};
          Object.keys(server).forEach(function (id) { desired[id] = server[id]; });
          seeded = true;
        }
        syncTiles();
        paintCart();
        var badge = document.querySelector('[data-cart-count]');
        if (badge) badge.textContent = cart.item_count;
      })
      .catch(function (e) { console.error('Order grid: cart read failed', e); });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var hit;

    if (t.closest('[data-mo-close]')) { closeModal(); return; }
    if (t.closest('[data-mo-qclose]')) { closeQuick(); return; }
    if ((hit = t.closest('[data-mo-quick]'))) { openQuick(+hit.getAttribute('data-mo-quick')); return; }

    if ((hit = t.closest('[data-mo-colour]'))) {
      var pid = +hit.getAttribute('data-mo-pid');
      chosen[pid] = +hit.getAttribute('data-mo-colour');
      if (openId === pid) drawModal();
      if (qvId === pid) drawQuick();
      return;
    }

    if ((hit = t.closest('[data-mo-variant]'))) {
      if (hit.disabled) return;
      var delta = t.closest('[data-mo-minus]') ? -1 : 1;
      bump(+hit.getAttribute('data-mo-pid'), +hit.getAttribute('data-mo-variant'), delta);
      return;
    }

    if ((hit = t.closest('[data-mo-step]'))) {
      bump(+hit.getAttribute('data-mo-pid'), +hit.getAttribute('data-mo-vid'),
        +hit.getAttribute('data-mo-step'));
      return;
    }
    if ((hit = t.closest('[data-mo-remove]'))) {
      delete desired[+hit.getAttribute('data-mo-vid')];
      syncTiles(); paintCart(); scheduleSync();
      return;
    }

    // Retail stores skip the compact popup and go straight to full details.
    if ((hit = t.closest('[data-mo-card]'))) {
      var cardId = +hit.getAttribute('data-mo-card');
      if (SINGLE) openQuick(cardId); else openModal(cardId);
      return;
    }

    if (t.closest('[data-mo-review]')) { drawer.hidden = !drawer.hidden; return; }
    if (t.closest('[data-mo-drawer-close]')) { drawer.hidden = true; return; }

    if ((hit = t.closest('[data-mo-type]'))) {
      rail.querySelectorAll('[data-mo-type]').forEach(function (x) { x.classList.remove('is-active'); });
      hit.classList.add('is-active');
      filter = hit.getAttribute('data-mo-type');
      renderGrid(); syncTiles();
      return;
    }

    if (t === scrim) { closeModal(); return; }
    if (t === qscrim) { closeQuick(); return; }
  });

  if (searchEl) {
    searchEl.addEventListener('input', function () {
      search = searchEl.value.trim().toLowerCase();
      renderGrid(); syncTiles();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (qvId) closeQuick();
    else if (openId) closeModal();
  });

  renderGrid();
  paintCart();
  readCart(false);
})();
